import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Redirect to the canonical production domain
if (window.location.hostname === 'directsubmit.nycastings.com') {
  window.location.replace(
    'https://directsubmit.com' +
      window.location.pathname +
      window.location.search +
      window.location.hash
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();